'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { actions as notify } from 'redux-notifications';

import { ERROR } from '../../../consts';
import { COMMENT } from '../../../app/Comments/actionTypes';
import { createComment, hideCommentForm, removeComment, updateComment } from '../../../app/Comments/actions';

class CommentForm extends Component {
  constructor (props) {
    super(props);

    this.state = {
      text: props.form.get('text', '') || '',
      errors: []
    };

    this.hideCommentForm = props.hideCommentForm.bind(this);
    this.createComment = props.createComment.bind(this);
    this.updateComment = props.updateComment.bind(this);
    this.removeComment = props.removeComment.bind(this);
    this.notifSend = props.notifSend.bind(this);

    this.handlerClose = this.handlerClose.bind(this);
    this.handlerChangeText = this.handlerChangeText.bind(this);
    this.handlerSaveComment = this.handlerSaveComment.bind(this);
    this.handlerRemoveComment = this.handlerRemoveComment.bind(this);

    this.clearErrors = () => this.setState({errors: []});
  }

  handlerClose (e) {
    e.preventDefault();
    e.stopPropagation();
    this.hideCommentForm();
  }

  handlerChangeText (e) {
    const text = e.target.value;
    this.setState({
      text
    });

    if (text) {
      this.clearErrors();
    }
  }

  handlerSaveComment () {
    const commentId = this.props.form.get('id');
    const text = this.state.text;
    this.clearErrors();

    const promise = commentId ? this.updateComment(text) : this.createComment(text);
    promise.then(action => {
      if (action.type === COMMENT + ERROR) {
        const errors = action.payload
          ? action.payload.map(err => err.message) : [];

        this.setState({
          errors
        });
      } else {
        this.notifSend({
          message: 'Комментарий сохранен',
          dismissAfter: 2000
        });
      }
    });
  }

  handlerRemoveComment () {
    this.removeComment().then(action => {
      this.notifSend({
        message: 'Комментарий удален',
        dismissAfter: 2000
      });
    });
  }

  componentWillReceiveProps (nextProps, nextContext) {
    const nextText = nextProps.form.get('text');
    if ((this.props.form.get('text') !== nextText) || !nextText) {
      this.setState({
        text: nextProps.form.get('text', '') || '',
        errors: []
      });
    }
  }

  render () {
    const form = this.props.form;
    const isOpen = form.get('open') || false;
    const isLoading = form.get('loading') || false;
    const commentId = this.props.form.get('id');
    const modalClass = classNames('modal full-screen', {
      'open fade in': isOpen
    });

    return (
      <div className={modalClass}>
        <div className='modal-dialog full-screen'>
          <div className='modal-content animate-top'>
            <div className='modal-box comment-modal'>
              <button type='button' className='close' onClick={this.handlerClose}>×</button>
              {
                isOpen && (
                  <div className='form-container'>
                    <h2 className='header'>Комментарий</h2>

                    <div className={'form' + (this.state.errors.length ? ' error' : '')}>
                      <textarea autoFocus value={this.state.text} cols='30' rows='10' onChange={this.handlerChangeText} />
                      {
                        this.state.errors.map(err => (<span className='error-message'>{err}</span>))
                      }
                    </div>

                    {
                      isLoading ? (
                        <div className='controls'>
                          loading...
                        </div>
                      ) : (
                        <div className='controls'>
                          <button type='button' onClick={this.handlerSaveComment} className='btn btn-primary'>{commentId ? 'Изменить' : 'Сохранить'}</button>
                          {commentId && <button type='button' onClick={this.handlerRemoveComment} className='btn btn-secondary'>Удалить</button>}
                        </div>
                      )
                    }
                  </div>
                )
              }
            </div>
          </div>
        </div>
        <TransitionGroup>
          {
            isOpen &&
            <CSSTransition key={'modal-backdrop'} appear classNames='fade' timeout={300}>
              <div className='modal-backdrop full-screen' />
            </CSSTransition>
          }
        </TransitionGroup>
      </div>
    );
  }
}

CommentForm.propTypes = {
  form: PropTypes.object.isRequired,
  hideCommentForm: PropTypes.func.isRequired,
  createComment: PropTypes.func.isRequired,
  updateComment: PropTypes.func.isRequired,
  removeComment: PropTypes.func.isRequired,
  notifSend: PropTypes.func.isRequired
};

CommentForm.defaultProps = {};

function mapStateToProps (state) {
  return {
    form: state.getIn(['comments', 'form'])
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    hideCommentForm,
    createComment,
    updateComment,
    removeComment,
    notifSend: notify.notifSend
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentForm);



// WEBPACK FOOTER //
// ./src/ui/Controls/Comments/CommentForm.jsx